import { useContext } from 'react';
import { CadastroComposicaoContextData } from '../../types';
import { CadastroComposicaoContext } from '../../context/CadastroComposicaoContext';

export const useCadastroComposicao = (): CadastroComposicaoContextData =>
  useContext(CadastroComposicaoContext);
